import styled from "styled-components";

export const ContainerAllergies = styled.div`
overflow: hidden;
`;

export const HeaderAllergies = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2px;
`;
